export default __webpack_public_path__ + "static/media/tigres.bca80a96.png";